'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowDownB = function IoArrowDownB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.7 14.5c-0.1-0.2-0.2-0.5-0.2-0.7 0-0.8 0.6-1.3 1.3-1.3h22.4c0.7 0 1.3 0.5 1.3 1.3 0 0.2-0.1 0.4-0.2 0.6l-0.2 0.2-10.6 12.2c-0.4 0.4-0.9 0.7-1.5 0.7s-1.1-0.3-1.5-0.7l-10.6-12.2z' })
        )
    );
};

exports.default = IoArrowDownB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-down-b.js
// module id = 1932
// module chunks = 0